import React from 'react';
import { FormGroup } from '@mui/material';
import { RewardsListAttributes, RewardsListI18nAttributes } from '@loyalty/editor-components';
import { useTranslation } from 'react-i18next';
import { InputTextField } from '../../../../shared/forms/fields/InputTextField';
import { SwitchField } from '../../../../shared/forms/fields/SwitchField';
import { Trait } from '../utils/Trait';
import { TraitFormValue } from '../types';

type FormValue = TraitFormValue<RewardsListAttributes, RewardsListI18nAttributes>;

export function RewardsListWidgetTraits() {
  const { t } = useTranslation();

  return (
    <FormGroup>
      <Trait>
        <SwitchField<FormValue>
          name="attributes.showRewardStock"
          label={t('editor.rewards.traits.showStock')}
        />
      </Trait>
      <Trait>
        <InputTextField<FormValue>
          type="text"
          name="i18nAttributes.redeemButtonLabel"
          label={t('editor.rewards.traits.redeemButtonLabel')}
          // placeholder issue
          placeholder={t('editor.rewards.list.item.button')}
        />
      </Trait>
    </FormGroup>
  );
}
